export enum AppointmentStatusEnum {
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  TO_RESCHEDULE = 'TO_RESCHEDULE',
  TO_CONFIRM = 'TO_CONFIRM',
  CONFIRMED = 'CONFIRMED',
  SCHEDULED = 'SCHEDULED'
}
